import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_WOCOMM_CATEGORIES, GET_SINGLE_WOCOMM_CATEGORY} from "../type";
import Filter from "../../utils/Filter";

// Fetch wocommerce Categories
export const fetchWocommCategories = (query) => async (dispatch) => {
    try {
        const search = (query.search===undefined||query.search==="") ? "":query.search;
        const apiEndpoint = API_END_POINTS.FETCH_WOCOMM_CATEGORIES;
        const response = await JsonInterceptor.get(`${apiEndpoint}/?page=${query.pageNumber}&limit=${query.pageSize}&search=${search}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data&&response.data.docs,query);
        dispatch({
            type: GET_WOCOMM_CATEGORIES,
            payload: response.data.docs,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Get Single wocommerce Category
export const fetchSingleWocommCategory= (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCTH_SINGLE_WOCOMM_CATEGORY;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WOCOMM_CATEGORY,
            payload: response.data.docs,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// update Single wocommerce Category
export const updateWocommCategory = (data) => async (dispatch) => {
    try {
        const body ={order :data.order}
        const apiEndpoint = API_END_POINTS.UPDATE_WOCOMM_CATEGORY;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${data.id}`,body)
    //   dispatch({
    //         type: GET_SINGLE_WOCOMM_CATEGORY,
    //         payload: response.data,
    //     });
        return response.data;
    } catch (error) {
        console.log("error", error);
    }
};
